module.exports = __webpack_public_path__ + "img/zzpr-logo.237f6256.svg";